import { PRProductRequest } from '@app/models/pr_products/PRProductRequest';
import {
  PRProductTableData,
  PRProductTableRow,
  PRProductResponse,
  PRProductApiData,
} from '@app/models/pr_products/PRProductResponse';
import { post, get } from './http.api';
import { Parameters } from '@app/models/Parameters';

export const getPRProductTableData = async (parameters: Parameters): Promise<PRProductTableData> => {
  try {
    const { data, status } = await get<any>('pr_products', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const PRProducts: PRProductTableRow[] = data?.pr_products?.data?.map((pr_products: any) => ({
      id: pr_products.id,
      code: pr_products.code,
      name: pr_products.name,
      pr_category_id: pr_products.pr_category_id,
      status: pr_products.status,
    }));

    return {
      data: PRProducts,
      status_options: data.status_options,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Departments:', error);
    throw error;
  }
};

export const getAllPRProducts = async (): Promise<PRProductResponse> => {
  try {
    const { data, status } = await get<PRProductResponse>(`pr_products`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getPRProductById = async (id: number): Promise<PRProductResponse> => {
  try {
    const { data, status } = await get<PRProductResponse>(`pr_products/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storePRProduct = async (DepartmentData: PRProductRequest) => {
  try {
    const response = await post<any>('pr_products/create', DepartmentData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createPRProduct = async (): Promise<PRProductApiData> => {
  try {
    const { data, status } = await get<PRProductApiData>(`pr_products/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showPRProduct = async (id: number) => {
  try {
    const { data, status } = await get<PRProductApiData>(`pr_products/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editPRProduct = async (id: number) => {
  try {
    const { data, status } = await get<PRProductApiData>(`pr_products/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updatePRProduct = async (id: number, Updatecategory: PRProductRequest) => {
  try {
    const { data, status } = await post<PRProductRequest>(`pr_products/${id}/edit`, Updatecategory, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
